import React, { memo, InputHTMLAttributes } from 'react';
import { Colors, theme } from '@app/theme';
import { HorizontalTextAndImageSelectionBlock } from './TextAndImageSelectionBlock/HorizontalTextAndImageSelectionBlock';
import { useMediaQuery } from 'react-responsive';
import { VerticalTextAndImageSelectionBlock } from './TextAndImageSelectionBlock/VerticalTextAndImageSelectionBlock';

interface Props extends InputHTMLAttributes<HTMLInputElement> {
  illustration?: string;
  title: string;
  description?: string;
  checked?: boolean;
  disabled?: boolean;
  tooltip?: string;
  centerChip?: {
    label: string;
    color: Colors | undefined;
  };
  topChip?: {
    label: string;
    color: Colors | undefined;
    position?: 'center' | 'right';
  };
  isCompact?: boolean;
  horizontal?: boolean;
  trackingName?: string;
}

export const TextAndImageSelectionBlock = memo((props: Props) => {
  const isDesktop = useMediaQuery({ query: theme.mediaContent.desktop });
  if (isDesktop && !props.horizontal) {
    return <VerticalTextAndImageSelectionBlock {...props} />;
  }
  return <HorizontalTextAndImageSelectionBlock {...props} />;
});
